/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Submission } from '../../models/submission';
import { SubmissionPagedResult } from '../../models/submission-paged-result';

export interface MonitorSearchSubmissionsSearchSubmissionsPost$Params {
  pageNumber?: number;
  pageSize?: number;
      body?: Submission
}

export function monitorSearchSubmissionsSearchSubmissionsPost(http: HttpClient, rootUrl: string, params?: MonitorSearchSubmissionsSearchSubmissionsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubmissionPagedResult>> {
  const rb = new RequestBuilder(rootUrl, monitorSearchSubmissionsSearchSubmissionsPost.PATH, 'post');
  if (params) {
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubmissionPagedResult>;
    })
  );
}

monitorSearchSubmissionsSearchSubmissionsPost.PATH = '/Monitor/SearchSubmissions/search-submissions';
